import LocalStorageUtils from '@/utils/localStorageUtils'

const saved = LocalStorageUtils.favorites || {}

function saveState (state)
{
    LocalStorageUtils.favorites = state
}

function setObjectState (state, objectCategory, objectId, isFavorite)
{
    if (isFavorite)
    {
        if (!state[objectCategory].includes(objectId))
        {
            state[objectCategory].push(objectId)
        }
    }
    else
    {
        const index = state[objectCategory].indexOf(objectId)
        if (index >= 0)
        {
            state[objectCategory].splice(index, 1)
        }
    }
    
    saveState(state)
}

export default
{
    namespaced: true,
    
    state:
    {
        actualities: saved.actualities || [],
        events: saved.events || [],
        usefulInfos: saved.usefulInfos || [],
        stores: saved.stores || [],
    },
    mutations:
    {
        setActualityState (state, {actualityId, isFavorite} = {}) 
        {
            setObjectState(state, 'actualities', actualityId, isFavorite)
        },
        setEventState (state, {eventId, isFavorite} = {}) 
        {
            setObjectState(state, 'events', eventId, isFavorite)
        },
        setUsefulInfoState (state, {usefulInfoId, isFavorite} = {}) 
        {
            setObjectState(state, 'usefulInfos', usefulInfoId, isFavorite)
        },
        setStoreState (state, {storeId, isFavorite} = {}) 
        {
            setObjectState(state, 'stores', storeId, isFavorite)
        },
    }
}


// WEBPACK FOOTER //
// ./src/stores/favorites.js